import i18n, { t } from 'i18next'
import en from './translations/en.json'
import fr from './translations/fr.json'
import LanguageDetector from 'i18next-browser-languagedetector'
import Translations from './translations/Translations'

const resources = {
  en: { translation: en },
  fr: { translation: fr },
}

i18n.use(LanguageDetector).init({
  detection: {
    order: [
      'navigator',
      'cookie',
      'localStorage',
      'sessionStorage',
      'htmlTag',
      'querystring',
    ],
  },
  debug: false,
  resources,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export type TranslationKeys = keyof Translations

export function tt(key: TranslationKeys, vars?: any) {
  return t(key, vars)
}

export default i18n
